import { NgClass, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatCard, MatCardContent } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { MatTooltip } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { ClassDirective, StyleDirective } from '@ngbracket/ngx-layout/extended';
import { LayoutAlignDirective, LayoutDirective, LayoutGapDirective } from '@ngbracket/ngx-layout/flex';

import * as _ from 'lodash';
import { COLORS } from '../../constants/colors';
import { Map } from '../../models/map';
import { Play } from '../../models/play';
import { StoreService } from '../../services/store.service';
import { PlayMapComponent } from '../play-map/play-map.component';

@Component({
  selector: 'bt-play-thumb',
  templateUrl: './play-thumb.component.html',
  styleUrls: ['./play-thumb.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ClassDirective,
    LayoutAlignDirective,
    LayoutDirective,
    LayoutGapDirective,
    MatCard,
    MatCardContent,
    MatIcon,
    MatIconButton,
    MatMenu,
    MatMenuTrigger,
    MatTooltip,
    NgClass,
    NgStyle,
    PlayMapComponent,
    RouterLink,
    StyleDirective
  ]
})
export class PlayThumbComponent implements OnInit {
  @Input() play: Play;
  @Input() showActions = true;
  @Input() showActive = false;

  storeMap: Map;
  backgroundColor = '#303030';

  constructor(protected storeService: StoreService) {
  }

  ngOnInit() {
    this.backgroundColor = this.getPlayColor(this.play);
    this.storeService.getMap(this.play.storeId).subscribe((map) => {
      this.storeMap = map;
    });
  }

  getPlayTypeName() {
    return Play.getPlayTypeName(this.play.playType);
  }

  getPlayColor(play: Play) {
    let color = '#303030';

    if (!_.isNil(play)) {
      switch (play.playType) {
        case Play.TYPE_INSIGHT:
          color = COLORS.INSIGHT;
          break;
        case Play.TYPE_INSPECT:
          color = COLORS.INSPECT;
          break;
        case Play.TYPE_FOCUS:
          color = COLORS.FOCUS;
          break;
        case Play.TYPE_RFID:
          color = COLORS.RFID;
          break;
        case Play.TYPE_SECURITY_CHECKPOINT_WALK:
          color = COLORS.SECURITY_CHECKPOINT;
          break;
        case Play.TYPE_SECURITY_PATROL:
          color = COLORS.SECURITY_PATROL;
          break;
      }
    }

    return color;
  }
}
